export default __webpack_public_path__ + "static/media/eSalariumanima.dc4b7286.png";